import axios from 'axios';
import apiUrl from './apiUrl';

export default async function getLoginData(): Promise<any> {
  return axios.get(`${apiUrl()}/oauth2/logindata`);
}
